import {
  digitalRevenueList,
  npdList,
  metricsTablePCUFollwerList,
  metricsDigitalRevenueList,
} from '@/pages/intelligence/pages/TopCharts/_config/metricOptions';
import { DETAIL_PAGEID } from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/_config';
import { steamPCUFollowerList } from '@/pages/intelligence/pages/TopCharts/_config/metricOptions';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';

//获取有效的默认pageid: pc详情默认第一个为pcu, console详情默认第一个为digitalRevenue
// export const getDefalutFirstActivePage = (
//   pageId: string,
//   entityType: string,
// ): string => {
//   // 所有有效的 pageId 值
//   // const pageIds = Object.values(DETAIL_PAGEID);
//   const pageIds = [DETAIL_PAGEID.pcu, DETAIL_PAGEID.digitalRevenue, DETAIL_PAGEID.physicalRevenue];

//   // 如果传入的 pageId 无效，则选择第一个页签的回退值
//   const getPageIdFallback =
//     entityType === 'pc' ? DETAIL_PAGEID.pcu : DETAIL_PAGEID.digitalRevenue;
//   const selectedPageId = pageIds.includes(pageId) ? pageId : getPageIdFallback;
//   return selectedPageId;
// };

// export const getPageParametersByPageId = (
//   pageId: string,
//   entityType: string,
// ) => {
//   const selectedPageId = getDefalutFirstActivePage(pageId, entityType);

//   // 每个页面的参数定义
//   const pageParameters = {
//     digitalRevenue: {
//       source: 'mscience',
//       tab_name: 'digital_revenue',
//       regions: ['us'],
//       segment: 'All',
//       sort_field: 'digitalRevenue',
//     },
//     physicalRevenue: {
//       source: 'npd',
//       tab_name: 'physical_revenue',
//       regions: ['us'],
//       segment: '',
//       sort_field: 'revenue',
//     },
//     pcu: {
//       source: 'steamcharts',
//       tab_name: 'pcu',
//       regions: ['global'],
//       segment: '',
//       sort_field: 'pcu',
//     },
//   } as any;

//   // 返回选定页面对应的参数
//   return pageParameters[selectedPageId];
// };

export const getMetricValueOfCvm = (cvm: any, metricKey: string) => {
  if (!cvm || !metricKey) {
    return {};
  }
  const metrics = cvm.metrics || [];
  const metric = metrics.find((item: any) => item.metric === metricKey);
  if (!metric) {
    return {};
  }
  return { ...metric, growth_ratio: metric?.growth_ratio };
};

export const getPUCDigitalPyhsicalList = (
  pageId: string,
  tab: 'stats' | 'countries',
  entityType: string,
) => {
  // console.log(pageId)
  if (pageId === DETAIL_PAGEID.pcu) {
    if(entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE){
      return  steamPCUFollowerList
    }
    return metricsTablePCUFollwerList;
  } else if (pageId === DETAIL_PAGEID.digitalRevenue) {
    if (tab === 'countries') {
      return metricsDigitalRevenueList;
    }
    return digitalRevenueList;
  } else if (pageId === DETAIL_PAGEID.physicalRevenue) {
    return npdList;
  }
  return [];
};

export const getPUCDigitalPyhsicalListTrendTitle = (tab: string, pageId: string) => {
  switch (pageId) {
    case DETAIL_PAGEID.pcu:
      switch (tab) {
        case 'acu':
          return 'dbi_acu';
        case 'steamreviews':
          return 'dbi_metric_steam_reviews';
        case 'steamfollowers':
          return 'dbi_metric_steam_followers';
        default:
          return 'dbi_pcu';
      }
    case DETAIL_PAGEID.digitalRevenue:
      return 'dbi_digital_revenue';
    case DETAIL_PAGEID.physicalRevenue:
      return 'dbi_physical_revenue';
      case DETAIL_PAGEID.gsd:
        return 'dbi_metric_gsd_sales_date';
    default:
      return 'dbi_acu';
  }

}